module.exports = __webpack_public_path__ + "static/media/commentaries.70c2b7f4.svg";